<template>
  <div v-if="artworks.length">
    <section-heading v-if="!noTitle" :text="$t('COMMON.LATEST_ARTWORKS')" />

    <v-container
      fluid
      :grid-list-xxl="isMobile"
      :grid-list-xxxl="!isMobile"
      text-xs-center
      px-0
      pt-0
    >
      <!-- :class="{ 'py-4':  $vuetify.breakpoint.smAndDown}" -->
      <v-layout row class="horizontal-scroll">
        <v-flex
          :py-3="$vuetify.breakpoint.xsOnly"
          sm6
          md3
          v-for="artwork in artworks.slice(0, isMobile ? 10 : 4)"
          :key="artwork.id"
        >
          <home-artwork :artwork="artwork" />
        </v-flex>
      </v-layout>
    </v-container>
    <div class="text-xs-center" v-if="!noLink">
      <tk-btn
        dark
        color="black"
        large
        :to="{name: 'search', query: { page: 1 , sortby: 'artworks' }}"
      >
        <span class="caption font-weight-medium">{{ $t('ARTWORK.VIEW_ALL')}}</span>
      </tk-btn>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/services/RepositoryFactory";
import { ErrorHandler } from "@/utils/ErrorHandler";
import BaseTitle from "@/components/base/BaseTitle.vue";
import SectionHeading from "./SectionHeading.vue";
import HomeArtwork from "./HomeArtwork.vue";
import { ArtworkTransformer } from "@/services/artwork/ArtworkTransformer";

const artworksRepo = RepositoryFactory.artworks();
const handler = new ErrorHandler();

export default {
  components: {
    BaseTitle,
    SectionHeading,
    HomeArtwork,
  },

  props: {
    noTitle: Boolean,
    noLink: Boolean
  },

  data() {
    return {
      artworks: [],
    };
  },
  computed: {
    textSizeClass() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "display-3";
      }
      return "display-1";
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      await handler.handle(async () => {
        if (window.Taiko && window.Taiko.latest_artworks) {
          this.artworks = window.Taiko.latest_artworks.map((a) =>
            new ArtworkTransformer().toClass(a)
          );
        }

        if (!this.artworks || !this.artworks.length) {
          this.artworks = await artworksRepo.latestArtworks();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.horizontal-scroll {
  @media (max-width: 960px) {
    overflow-x: scroll;
  }
}
</style>
